<template>
    <div class="changePassword">
        <div class="changePassword-content">
            <p class="changePassword-newNum">当前手机号码</p>
            <p class="changePassword-newNum-content">{{ parsePhoneToStar(userInfo.phoneNo) }}</p>
            <p class="changePhoen-newNum-tip">请输入正确的手机验证码，以确保用户本人操作</p>
            <div class="changePassword-code">
                <van-field v-model="code" center clearable placeholder="请输入短信验证码">
                    <template #button>
                        <span class="sendCodeBtn" @click="sendCode">{{ sendCodeText }}</span>
                    </template>
                </van-field>
            </div>
        </div>
        <div class="changePassword-confirm-btn">
            <van-button class="comfirm-btn" :disabled="disabled" @click="tochangePassword" color="#009AF3">下一步</van-button>
        </div>
    </div>
</template>

<script>
import { parsePhoneToStar, parseSmsKey } from "@/libs/parseData";
import { getUserInfoApi, sendSmsApi } from "@/api/index";
import config from "@/config/index";
export default {
    name: "ChangePassword",
    data() {
        return {
            userInfo: {},
            code: "",
            second: 60,
            timer: null,
            sendCodeText: "获取短信验证码",
        };
    },
    computed: {
        disabled() {
            if (this.code.length == 4) {
                return false;
            } else {
                return true;
            }
        },
    },
    created() {
        this.getUserInfo();
    },
    methods: {
        parsePhoneToStar,
        // 获取用户信息
        getUserInfo() {
            getUserInfoApi().then((res) => {
                this.userInfo = res.data;
            });
        },
        sendCode() {
            if (this.second == 60) {
                let params = {
                    accessKey: config.accessKey,
                    accessToken: parseSmsKey(this.userInfo.phoneNo),
                    phoneNo: this.userInfo.phoneNo,
                };
                sendSmsApi(params).then((res) => {
                    this.timer = setInterval(() => {
                        if (this.second > 0) {
                            this.second -= 1;
                            this.sendCodeText = this.second + "s后重新获取";
                        } else {
                            this.sendCodeText = "获取短信验证码";
                            this.second = 60;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                    this.$notify({
                        message: "验证码已发送，请注意查收",
                        color: "#009AF3",
                        background: "#D3E8FB",
                    });
                });
            } else {
            }
        },
        tochangePassword() {
            // let token = parseSmsKey(this.phone)
            this.$router.push({
                path: "/mine/userinfo/changeNewPassword",
                query: {
                    code: this.code,
                    phone: this.userInfo.phoneNo,
                },
            });
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";
.changePassword {
    min-height: 100vh;
    background-color: #fff;

    .changePassword-content {
        padding: 124px 72px;

        .changePassword-newNum {
            font-size: 32px;
            font-weight: 500;
            color: #666666;
        }

        .changePassword-newNum-content {
            font-size: 60px;
            font-weight: 500;
            color: #333333;
            margin: 23px 0 31px;
        }

        .changePhoen-newNum-tip {
            font-size: 26px;
            color: #999999;
        }
        .changePassword-code {
            margin-top: 150px;
            border-bottom: 1px solid #dbdada;
            padding-bottom: 34px;
            .sendCodeBtn {
                color: @main-color;
                font-size: 28px;
            }
        }
    }
    .changePassword-confirm-btn {
        padding: 24px;
        // margin-top: ;
    }
}
</style>
<style lang="less">
.changePassword-code {
    .van-cell {
        padding: 0;
    }
}
</style>
